<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold my-5">{{ item.contact }}</div>
            <div v-for="(matter,index) in item.matters" :key="index">
              <div class="font-semibold my-5">{{ matter.name }}</div>
              <div class="flex gap-1 pb-2">
                <feather-icon icon="DollarSignIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                <div class="font-medium">Expense Entries</div>
              </div>
              <a-table :dataSource="matter.expense_entries" :columns="columnsExpense" :pagination="false"  class="tbl-receivable">
                <template slot="description" slot-scope="text,record">
                  {{ limitTextTask(record.description) }}
                </template>
                <template slot="date" slot-scope="text,record">
                  {{ setDateFormat(record.date) }}
                </template>
                <template slot="usedInvoice" slot-scope="text,record">
                  <template v-if="record.is_used_in_invoice">Billed</template>
                  <template v-else>Unbilled</template>
                </template>
                <template slot="reference" slot-scope="text,record">
                  {{ limitTextTask(record.reference) }}
                </template>
                <template slot="user" slot-scope="text,record">
                  {{ record.user_name }}
                </template>
                <template slot="vendor" slot-scope="text,record">
                  {{ record.vendor }}
                </template>
                <template slot="footer">
                  <template v-if="matter.expense_entries.length">
                    <div class="flex flex-col justify-evenly gap-y-2">
                      <div class="flex justify-between gap-4">
                        <div class="font-bold">Billed Total:</div>
                        <div>{{ currencySymbol + sumColAmount(matter.expense_entries,'amount').filterBilled }}</div>
                      </div>
                      <div class="flex justify-between gap-4">
                        <div class="font-bold">UnBilled Total:</div>
                        <div>{{ currencySymbol + sumColAmount(matter.expense_entries,'amount').filterUnBilled }}</div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
              <div class="flex gap-1 py-5">
                <feather-icon icon="ClockIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                <div class="font-medium">Time Entries</div>
              </div>
              <a-table :dataSource="matter.time_entries" :columns="columnsTimes" :pagination="false"  class="tbl-receivable">
                <template slot="description" slot-scope="text,record">
                  {{ limitTextTask(record.description) }}
                </template>
                <template slot="date" slot-scope="text,record">
                  {{ setDateFormat(record.date) }}
                </template>
                <template slot="usedInvoice" slot-scope="text,record">
                  <template v-if="record.is_used_in_invoice">Billed</template>
                  <template v-else>Unbilled</template>
                </template>
                <template slot="reference" slot-scope="text,record">
                  {{ limitTextTask(record.reference) }}
                </template>
                <template slot="user" slot-scope="text,record">
                  {{ record.user_name }}
                </template>
                <template slot="vendor" slot-scope="text,record">
                  {{ record.vendor }}
                </template>
                <template slot="total" slot-scope="text,record">
                  {{ (record.rate * record.duration).toFixed(2)  }}
                </template>
                <template slot="footer">
                  <template v-if="matter.time_entries.length">
                    <div class="flex flex-col justify-evenly gap-y-2">
                      <div class="flex justify-between gap-4">
                        <div class="font-bold">Billed Total:</div>
                        <div>{{ currencySymbol + sumColAmount(matter.time_entries,'amount_time').filterBilled }}</div>
                      </div>
                      <div class="flex justify-between gap-4">
                        <div class="font-bold">UnBilled Total:</div>
                        <div>{{ currencySymbol + sumColAmount(matter.time_entries,'amount_time').filterUnBilled }}</div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-end w-full md:w-1/2"
              :is_include_matter="false"
              @selectSearch="handleSearch"
              placeholder="Enter Name Of Client"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent class="mt-4" :dateForm="form" />
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','ClientReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from '@/components/pdf/ExportPdf'
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columnsExpense = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: '1',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: '2',
    scopedSlots: { customRender: 'user' },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Used invoice',
    dataIndex: 'used_invoice',
    key: '4',
    scopedSlots: { customRender: 'usedInvoice' },
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: '5',
    scopedSlots: { customRender: 'reference' },
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    key: '6',
    scopedSlots: { customRender: 'vendor' },
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: '7',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: '8',
  },
  {
    title: 'Total',
    dataIndex: 'amount',
    key: '9',
  },
]
const columnsTimes = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: '1',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: '2',
    scopedSlots: { customRender: 'user' },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Used invoice',
    dataIndex: 'used_invoice',
    key: '4',
    scopedSlots: { customRender: 'usedInvoice' },
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: '5',
    scopedSlots: { customRender: 'reference' },
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: '6',
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
    key: '7',
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: '8',
    scopedSlots: { customRender: 'total' },
  },
]

export default {
  name: "ComponentClientActivity",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      checked_matter_client: null,
      title:'Client Activity',
      columnsExpense,
      columnsTimes,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  methods:{
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.contact) query.push({ field: 'id', condition: '=', value: values.contact, operation: 'and' })
            if (values.practice_area) query.push({ field:'client_matters__practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('contact/report/activity',{ query: query.length ? query : undefined })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    sumColAmount(arr,field){
      if (field === 'amount_time') {
        const filterBilled   = arr.filter(item => item.is_used_in_invoice).map(amount => amount['rate'] * amount['duration']).reduce((a, b) => a + b, 0)
        const filterUnBilled = arr.filter(item => !item.is_used_in_invoice).map(amount => amount['rate'] * amount['duration']).reduce((a, b) => a + b, 0)
        return { filterBilled,filterUnBilled }
      }else {
        const filterBilled   = arr.filter(item => item.is_used_in_invoice).map(amount => amount[field]).reduce((a, b) => a + b, 0)
        const filterUnBilled = arr.filter(item => !item.is_used_in_invoice).map(amount => amount[field]).reduce((a, b) => a + b, 0)
        return { filterBilled,filterUnBilled }
      }
    },
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
